import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const WhatsAppButton = () => {
  const location = useLocation();
  const [product, setProduct] = useState(null);
  const whatsappNumber = '919328566392';
  
  // Detect if on product page and fetch product data
  useEffect(() => {
    const match = location.pathname.match(/^\/product\/([^/]+)/);
    if (match) {
      const productId = match[1];
      axios.get(`${BACKEND_URL}/api/products/${productId}`)
        .then(res => setProduct(res.data))
        .catch(() => setProduct(null));
    } else {
      setProduct(null);
    }
  }, [location.pathname]);
  
  // Generate message based on context
  const getMessage = () => {
    if (product) {
      // Product inquiry message with details
      const productUrl = `https://jatfashionhouse.com/product/${product.id}`;
      const ean = product.variants?.[0]?.ean || product.sku || 'N/A';
      
      return `Hello JAT Fashion House,

I would like to inquire about this product.

Product: ${product.name}
Product Code: ${ean}
Product Link: ${productUrl}

Please provide more details.`;
    }
    
    // Default message for non-product pages
    return 'Hi JAT Fashion House, I have a query.';
  };
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(getMessage())}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float bg-[#25D366] hover:bg-[#20BA5A] p-4 rounded-full shadow-lg transition-all duration-300"
      data-testid="whatsapp-float-button"
      title={product ? 'Inquire about this product on WhatsApp' : 'Chat with us on WhatsApp'}
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
};

export default WhatsAppButton;